import { ExtractionReason, KnownExtractionReason } from "../domain/ExtractionReason";

const extractionDetailsToAccentKey: Record<KnownExtractionReason, string> = {
  [ExtractionReason.MISSING_DOCUMENT]: "documentation_area.extraction_failure.missing_document",
  [ExtractionReason.AUTH_ERROR]: "documentation_area.extraction_failure.auth_error",
  [ExtractionReason.ADMIN_FAILURE]: "documentation_area.extraction_failure.admin_failure",
  [ExtractionReason.SESSION_FLOW_ERROR]: "documentation_area.extraction_failure.session_flow_error",
  [ExtractionReason.ACTION_REQUIRED_FROM_USER]:
    "documentation_area.extraction_failure.action_required_from_user",
  [ExtractionReason.PENDING_ON_ASYNC_EXTRACTION]:
    "documentation_area.extraction_pending.pending_on_async_extraction",
  [ExtractionReason.BAD_CONFIGURATION]: "documentation_area.extraction_failure.bad_configuration",
  [ExtractionReason.BLOCKED_CREDENTIALS]:
    "documentation_area.extraction_failure.blocked_credentials",
  [ExtractionReason.DOCUMENT_NOT_FOUND]: "documentation_area.extraction_failure.document_not_found",
  [ExtractionReason.DOCUMENT_RESOLUTION_PENDING]:
    "documentation_area.extraction_pending.document_resolution_pending",
  [ExtractionReason.GENERIC]: "documentation_area.extraction_failure.generic",
  [ExtractionReason.GENERIC_ADMINISTRATION_UNAVAILABLE]:
    "documentation_area.extraction_failure.generic_administration_unavailable",
  [ExtractionReason.LOGIN_METHOD_SESSION_EXPIRED]:
    "documentation_area.extraction_failure.login_method_session_expired",
  [ExtractionReason.MFA_METHOD_NOT_SUPPORTED]:
    "documentation_area.extraction_failure.mfa_method_not_supported",
  [ExtractionReason.NO_LOGIN_METHODS_AVAILABLE]:
    "documentation_area.extraction_failure.no_login_methods_available",
  [ExtractionReason.REPRESENTATION_REQUIREMENTS_NOT_MET]:
    "documentation_area.extraction_failure.representation_requirements_not_met",
  [ExtractionReason.TIMEOUT]: "documentation_area.extraction_failure.timeout",
  [ExtractionReason.USER_ABORTED]: "documentation_area.extraction_failure.user_aborted",
  [ExtractionReason.USER_BLOCKED]: "documentation_area.extraction_failure.user_blocked",
  [ExtractionReason.USER_DISABLED]: "documentation_area.extraction_failure.user_disabled",
  [ExtractionReason.USER_NOT_AUTHENTICATED]:
    "documentation_area.extraction_failure.user_not_authenticated",
  [ExtractionReason.USER_NOT_REGISTERED]:
    "documentation_area.extraction_failure.user_not_registered",
  [ExtractionReason.USER_UNKNOWN]: "documentation_area.extraction_failure.user_unknown",
  [ExtractionReason.UNKNOWN]: "documentation_area.extraction_failure.unknown",
};

export function getValueFromExtractionDetails(extractionReason: ExtractionReason): string {
  return (
    extractionDetailsToAccentKey[extractionReason as KnownExtractionReason] ??
    extractionDetailsToAccentKey[ExtractionReason.UNKNOWN]
  );
}
